import { Component, ElementRef, Input, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core'

import { WebSocketSubject } from 'rxjs/webSocket'

import { Character, Room } from '@mmocld/data'
import { ChatMessage, Message } from '@mmocld/message'

import { CharacterService } from '../model/character.service'
import { Mode } from './chat.entity'
import { ChatService } from './chat.service'

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit {
  @Input() connectedCharacter?: Character
  @Input() joinedRoom?: Room
  @Input() ws!: WebSocketSubject<Message>

  chatMessages: ChatMessage[] = []
  characters: Character[] = []
  messageText = ''
  mode: Mode = { action: 'broadcast' }

  @ViewChild('chatBox') chatBoxElement!: ElementRef
  @ViewChildren('messages') messagesElement!: QueryList<any>
  isScrolledToBottom = true

  constructor(private chatService: ChatService, private characterService: CharacterService) {}

  ngOnInit() {
    this.ws.subscribe({
      next: (message) => {
        this.recieveMessage(message)
      },
    })
  }
  ngAfterViewInit() {
    this.messagesElement.changes.subscribe(() => {
      if (this.isScrolledToBottom) {
        const b = this.chatBoxElement.nativeElement
        b.scrollTop = b.scrollHeight - b.clientHeight
      }
    })
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['joinedRoom'].currentValue) this.mode = { action: 'broadcast' }
  }

  sendMessage() {
    switch (this.mode.action) {
      case 'broadcast':
        this.chatService.sendBroadcastMessage(this.ws, { text: this.messageText })
        break
      case 'room':
        this.chatService.sendRoomMessage(this.ws, { text: this.messageText })
        break
      case 'direct message':
        if (this.mode.to) {
          this.chatService.sendDirectMessage(this.ws, { text: this.messageText, to: this.mode.to })
        }
        break
    }
    this.messageText = ''
  }

  recieveMessage(message: Message) {
    if (!message.type?.startsWith('Chat')) return

    const chatMessage = <ChatMessage>message
    this.chatMessages.push(chatMessage)

    // from not undef but no char with that id in array
    if (chatMessage.body.from && !this.findCharacter(chatMessage.body.from)) {
      this.characterService.findOne(chatMessage.body.from).subscribe((character) => {
        this.characters.push(character)
      })
    }

    const b = this.chatBoxElement.nativeElement
    this.isScrolledToBottom = b.scrollHeight - b.clientHeight <= b.scrollTop + 1
  }

  findCharacter(characterId: string | undefined) {
    if (!characterId) {
      return undefined
    }
    return this.characters.find((c) => c.characterId === characterId)
  }

  setMode(mode: Mode) {
    this.mode = mode
  }

  getTextColorClass(selector: string) {
    switch (selector) {
      case 'ChatBroadcastMessage':
      case 'broadcast':
        return 'chat-message-text-broadcast'
      case 'ChatRoomMessage':
      case 'room':
        return 'chat-message-text-room'
      case 'ChatDirectMessage':
      case 'direct message':
        return 'chat-message-text-direct'
    }
    return 'chat-message-text-default'
  }
}
